import { RequestMethod, Result } from '@/typings';
import { ajaxResult } from '@/utils';

export const HistoryService = {
  index: (id: number): Promise<Result> => {
    const req = { url: '/ajax-histories', method: RequestMethod.Get, data: { id } };
    return ajaxResult(req);
  },
};
